<template>
    <div class="dflex">
        <img
            :src="require('../assets/w.png')"
            contain
            :height="height"
        >
        <div style="padding-left:10px;">
            <p :class="$style.name">高菲僱傭有限公司</p>
            <p class="fs10 showInLarge">GOLDEN WIN EMPLOYENT AGENCY LTD</p>
            <p class="fs10 gray showInSmall">GOLDEN WIN EMPLOYENT AGENCY LTD</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        height: {type: Number, default: 60},
    }
}
</script>
<style module>
.name {
    font-size:27px;
    padding-bottom:4px;
}
@media screen and (max-width: 770px) {
    .name {
        font-size:16px;
        padding-bottom:2px;
    }
}
</style>
